import { Component, OnInit, ViewEncapsulation } from '@angular/core';

/**
 * Component used to Show Header with Title in Confimation Dialog Modal Or in any other Modal or component.
 * To use this component import FnDialogModule in Module.
 */
@Component({
  selector: 'fn-dialog-header',
  templateUrl: 'fn-dialog-header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnDialogHeaderComponent implements OnInit {

  /**
   * Creates an instance of fn dialog header component.
   */
  constructor() {
  }

  /**
   * Implementing ngOnInit Event Handler.
   */
  ngOnInit() {
  }
}
